import { useQuery } from "react-query";
import { axiosClient } from "../services/axiosInstance";

const useGetSurveyStatus = () => {
  const data = useQuery(["getSurveyStatus"], () =>
    axiosClient.post(`Setting/GepSettingList?groupSettingId=23`)
  );
  return data;
};
export default useGetSurveyStatus;
